import {
  DEVICE_MODEL_IMPORT_CSV_TEMPLATE_TEXT,
  FILE_EXTENSIONS
} from "Constants";
import { protect } from "TsRoleGuards";
import { useTranslation } from "utilities/i18n";
import {
  fileUploadSchema,
  prepareFileForImport,
  TemplateDownloadButton
} from "./DevicesImport";
import { Import } from "./Import";

const DeviceModelsImport: React.FC = () => {
  const { t } = useTranslation();

  const getCSVRules = () => (
    <div className="mb-1">
      <p>{t("CSV_IMPORT_RULES_1_DEVICE_MODEL")}</p>
      <p>
        {t("CSV_IMPORT_RULES_2")} {t("CSV_IMPORT_RULES_HEADER")}
        <strong>{t("CSV_IMPORT_HEADER_MODELS")}</strong>
        {t("CSV_IMPORT_RULES_3")}
      </p>
      <p>
        {t("CSV_IMPORT_RULES_6", {
          entity: t("DEVICE_MODEL_other").toLowerCase()
        })}
      </p>
    </div>
  );

  return (
    <Import
      importType="DEVICE_MODEL"
      fileTypesAccepted={[FILE_EXTENSIONS.CSV, FILE_EXTENSIONS.ZIP]}
      validationSchema={fileUploadSchema}
      prepareFileForImport={prepareFileForImport}
      importRules={getCSVRules()}
      templateDownload={
        <TemplateDownloadButton
          template={DEVICE_MODEL_IMPORT_CSV_TEMPLATE_TEXT}
          fileName="Device-Models-Template.csv"
        />
      }
    />
  );
};

export default protect("UPDATE_SITES")(DeviceModelsImport);
